import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';

export const BannerInfoRequerimientoPersonal = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: { xs: 3, md: 4 },
        backgroundColor: '#F8F7FA', // Color de fondo muy suave
        borderRadius: 3,
        border: '1px solid #EAEAFF',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: 4,
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, flex: 1, minWidth: '300px' }}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: '50%',
              backgroundColor: '#E8E7FD',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <AutoAwesomeIcon sx={{ color: '#696CFF', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}
            >
              ¿Qué es el Requerimiento de Personal?
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500, maxWidth: '80%' }}
            >
              Esta sección te permite definir y organizar la cantidad de personal necesario para
              cubrir los diferentes turnos y áreas de tu hotel de manera óptima.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <GroupsOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Planificación eficiente
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Asigna la cantidad óptima de personal según la demanda de cada área.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <CalendarMonthOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Cobertura de turnos
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Asegura que cada turno cuente con el equipo necesario para operar.
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <TrendingUpOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}
              >
                Optimización de recursos
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                Evita el exceso o falta de personal, mejorando la eficiencia operativa.
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};
